var map = {
	"./": 9882,
	"./adefault.module.scss": 6570,
	"./crickettimes.module.scss": 2071,
	"./index": 9882,
	"./index.js": 9882,
	"./meutimao.module.scss": 1423,
	"./pulzo.module.scss": 5985,
	"./rows/advanced-row": 2981,
	"./rows/advanced-row/": 2981,
	"./rows/advanced-row/adefault.module.scss": 3125,
	"./rows/advanced-row/crickettimes.module.scss": 2683,
	"./rows/advanced-row/index": 2981,
	"./rows/advanced-row/index.js": 2981,
	"./rows/basic-row": 1800,
	"./rows/basic-row/": 1800,
	"./rows/basic-row/adefault.module.scss": 6969,
	"./rows/basic-row/crickettimes.module.scss": 1446,
	"./rows/basic-row/index": 1800,
	"./rows/basic-row/index.js": 1800,
	"./rows/basic-row/meutimao.module.scss": 7493,
	"./rows/basic-row/pulzo.module.scss": 6836,
	"./rows/basic-row/superdeporte.module.scss": 2795,
	"./rows/basic-row/talksport.module.scss": 6235,
	"./rows/basic-row/thesun.module.scss": 1044,
	"./superdeporte.module.scss": 7180,
	"./tabs": 4917,
	"./tabs/": 4917,
	"./tabs/adefault.module.scss": 7697,
	"./tabs/index": 4917,
	"./tabs/index.js": 4917,
	"./talksport.module.scss": 6879,
	"./thesun.module.scss": 2098,
	"./toplist": 9716,
	"./toplist/": 9716,
	"./toplist/adefault.module.scss": 5424,
	"./toplist/index": 9716,
	"./toplist/index.js": 9716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2618;